import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash"
import {SplitService} from "../../../commons/services/split-service.service";
import {Timeline, DataSetDataGroup, DataSetDataItem} from "vis-timeline";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {ResourcesAlertsService} from "../../services/resources-alerts.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {DataSet} from "vis-data";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {TasksDialogService} from "../../../tasks/services/tasks-dialog.service";
import {TaskDetailedServiceTimeModel} from "../../../tasks/models/task-detailed-service-time.model";

export class ResourcesGanttTimelineTestCtrl implements IController {
  range: any;
  sortType: any;
  resources: any;
  routes: any;
  tasks: any;
  totalResourcesCount: any;
  allocations: any;
  serviceAreas: any;
  selectedItemId: any;
  canEdit: any;
  queryString: any;
  onMoveItem: Function;
  onTaskChange: Function;
  onViewService: Function;
  onRightClickTask: Function;
  onSortTypeChange: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private purposeToSkillMap: any;
  private purposeToColor: any;
  private timeFormat: any;
  private shortDateFormat: any;
  private longDateFormat: any;
  private itemsDataSet: any;

  private serviceAreasMap: any;
  private isExpandedRoutes: any;

  /////////////////// ICONS ///////////////////
  private iconsUrl: any;
  private $groupIcon: any;
  private readonly $agentTypeIcon: any;
  private $vehicleIcon: any;
  private readonly $branchIcon: any;
  private readonly $serviceAreaIcon: any;
  private $routedRowIcon: any;
  private $defaultAgentIcon: any;
  private $routedIcon: any;

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private splitService: SplitService, private commonsService: CommonsService,
              private commonsDialogService: CommonsDialogService, private $timeout: ITimeoutService, private tasksConstants, private leanPlanningService: LeanPlanningService,
              private moment, private scheduleService: ScheduleService, private tasksDialogService: TasksDialogService,
              private bringozTimelineService: BringozTimelineService, private tasksService: TasksService, private resourcesAlertsService: ResourcesAlertsService, private leanPlanningConstants, private $log) {

    this.vis = require('vis-timeline');
    this.rrule = require('rrule');
    this.purposeToSkillMap = {
      Pickup: ['Delivery'],
      Dropoff: ['Delivery'],
      Operation: ['Merchandise', 'Order']
    };
    this.purposeToColor = this.tasksConstants.purposeToColor;
    const dateAndTimeConfig = splitService.getDateAndTimeConfig();
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;

    this.iconsUrl = {
      group: 'assets/images/icons/v2/resource.svg',
      agentType: 'assets/images/icons/v2/agent.svg',
      car: 'assets/images/icons/v2/privatecar.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      serviceArea: 'assets/images/icons/v2/service-area.svg',
      defaultAgent: 'assets/images/icons/v2/default-agent.svg',
      routed: 'assets/images/icons/v2/route.svg'
    }

    this.$groupIcon = document.createElement('IMG');
    this.$groupIcon.setAttribute("src", this.iconsUrl.group);
    this.$groupIcon.classList.add('bringoz-icon-small', 'white');

    this.$agentTypeIcon = document.createElement('IMG');
    this.$agentTypeIcon.setAttribute("src", this.iconsUrl.agentType);
    this.$agentTypeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$vehicleIcon = document.createElement('IMG');
    this.$vehicleIcon.setAttribute("src", this.iconsUrl.car);
    this.$vehicleIcon.classList.add('bringoz-icon-small', 'gray');

    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceAreaIcon = document.createElement('IMG');
    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'gray');

    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small');

    this.$defaultAgentIcon = document.createElement('IMG');
    this.$defaultAgentIcon.setAttribute("src", this.iconsUrl.defaultAgent);
    this.$defaultAgentIcon.classList.add('bringoz-icon-small', 'gray');

    this.$routedIcon = document.createElement('IMG');
    this.$routedIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedIcon.classList.add('bringoz-icon-small', 'routed');
  }

  $onInit() {
    this.serviceAreasMap = _.keyBy(this.serviceAreas, 'areaId');
    this.isExpandedRoutes = true;

    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const routesCount = _.filter(this.routes, (r) => {
          return _.get(r, 'planningResource.allocationId') === _.get(group, 'ref.id')
        }).length;

        if (group.isRoute) {

          const routeName = document.createElement('span');
          routeName.classList.add("br-body-2", "font-weight-600");
          routeName.textContent = 'Routes';
          // container1.classList.add("group-info-container");

          const mainContainerRoute = document.createElement('div');
          // mainContainerRoute.classList.add("group-route-container");
          const routeIcon = this.$routedRowIcon.cloneNode(true);
          routeIcon.classList.add('white');
          mainContainerRoute.appendChild(routeIcon);
          mainContainerRoute.appendChild(routeName);
          // mainContainerRoute.insertAdjacentElement('beforeend', $routedIcon);
          // mainContainerRoute.insertAdjacentElement('beforeend', routeName);
          return mainContainerRoute;
        }

        const groupColor = this.commonsService.getColorById(group.id);

        const container = document.createElement('div');
        container.classList.add("group-info-container");

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-info-main-container");

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("group-info-actions-container");
        actionsContainer.style.setProperty('background-color', groupColor);

        const resourceNameSpan = document.createElement('span');
        resourceNameSpan.classList.add("resource-name", "text-ellipsis", "br-body-3", "font-weight-500");
        resourceNameSpan.innerText = group.name;

        actionsContainer.appendChild(resourceNameSpan);

        if (!!routesCount) {
          const routeCountSpan = document.createElement('span');
          routeCountSpan.classList.add("routes-count", "br-head-1", "font-weight-600");
          routeCountSpan.textContent = routesCount + '';
          actionsContainer.appendChild(routeCountSpan);
          const routeIconGray = this.$routedRowIcon.cloneNode(true);
          routeIconGray.classList.add('gray');
          actionsContainer.appendChild(routeIconGray);
        }
        // actionsContainer.appendChild(growSpan);
        // actionsContainer.appendChild(actionButton);

        const serviceAreas = this._getServiceAreasByMap(group.ref.serviceAreaIds);

        const values = [
          // {icon: $agentTypeIcon, key: 'Agent Type', values: [group.agentType, group.requiredSkills]},
          {icon: this.$agentTypeIcon, key: 'Default Agent', values: [group.agentName, group.agentType]}, //group.agentName
          // {icon: $vehicleIcon, key: 'Vehicle', value: $filter('translate')(group.vehicleType)},
          {icon: this.$serviceAreaIcon, key: 'Service Areas', value: this._getServiceAreaNames(serviceAreas)},
          {icon: this.$branchIcon, key: 'Branch', value: group.branchesCount}
        ];

        _.forEach(values, (v, index) => {

          const element = document.createElement('div');
          element.classList.add("table-item");

          const iconContainer = document.createElement('div');
          iconContainer.classList.add("icon-container");

          const icon = angular.copy(v.icon);

          if (v.key === 'Default Agent') {

            element.insertAdjacentElement('beforeend', iconContainer);
            iconContainer.insertAdjacentElement('beforeend', icon);

            _.forEach(v.values, (value, index) => {
              if (index === 0) {
                const agentName = document.createElement('span');
                agentName.textContent = value;
                element.insertAdjacentElement('beforeend', agentName);
              }
              if (index === 1) {
                const agentType = document.createElement('span');
                agentType.classList.add("margin-left-5", "font-weight-600");
                agentType.textContent = value;

                element.insertAdjacentElement('beforeend', agentType);
              }
            });

            container.insertAdjacentElement('beforeend', element);

          } else {
            const tooltip = document.createElement('div');
            tooltip.classList.add("timeline-icon-tooltip");

            const tooltipContainer = document.createElement('div');
            tooltipContainer.classList.add("tooltip-container");
            tooltipContainer.textContent = this.$filter('translate')(v.key);

            tooltip.insertAdjacentElement('beforeend', tooltipContainer);
            iconContainer.insertAdjacentElement('beforeend', icon);
            iconContainer.insertAdjacentElement('beforeend', tooltip);

            const span = document.createElement('span');
            span.textContent = v.value;

            element.insertAdjacentElement('beforeend', iconContainer);
            element.insertAdjacentElement('beforeend', span);
            container.insertAdjacentElement('beforeend', element);
          }
        });

        mainContainer.insertAdjacentElement('beforeend', actionsContainer);
        mainContainer.insertAdjacentElement('beforeend', container);


        return mainContainer;
      },
      onMoving: (item, callback) => {
        const routeRef = this.routes.find(r => {
          return item.routeId === r.id;
        })
        const actions = this.leanPlanningService.getRoutesActionsMap([routeRef]);
        if (!actions.editRoute) {
          callback(null);
          return;
        }

        callback(item); // updating the item
      },
      onMove: (item, callback) => {
        const serviceIds = item.serviceIds || [item.serviceId];
        const groupToRef = this.groupsDataSet.get([item.group])[0];
        const routeFromRef = _.find(this.routes, ['id', item.routeId]);
        const routeToRef = groupToRef.isRoute ? _.find(this.routes, (route) => {

          // return route.planningResource.allocationId === _.get(groupToRef, 'ref.id');
          return route.planningResource.allocationId === _.get(groupToRef, 'ref.id') &&
            (
              _.isEqual(this.moment(item.start).valueOf(), this.moment(route.notBefore).valueOf()) ||
              _.isEqual(this.moment(item.end).valueOf(), this.moment(route.notAfter).valueOf()) ||
              this.moment(item.start).isBetween(this.moment(route.notBefore), this.moment(route.notAfter))
            );
        }) : undefined

        let allocationItems;
        let allocationIds;
        const fromRouteId = item.routeId;
        let toRouteId;
        let isBetweenRoutes = false;
        const isBetweenDays = !this.moment(this.moment(item.start).format("MM/DD/YYYY")).isSame(this.moment(item.startTime).format("MM/DD/YYYY")) &&
          !this.moment(this.moment(item.end).format("MM/DD/YYYY")).isSame(this.moment(item.endTime).format("MM/DD/YYYY"));

        callback(item);

        if (!!routeToRef?.isBlockedByUser) {
          this.resourcesAlertsService.timelineRouteIsBlocked();
          callback(null);
          return;
        }

        if (!_.intersectionWith(groupToRef.requiredSkills, this.purposeToSkillMap[item.purpose], _.isEqual).length) {
          this.resourcesAlertsService.timelineNoMatchingSkillsInfo();
          callback(null);
          return;
        }

        const canMoveFromRoute = this.leanPlanningService.getRoutesActionsMap([routeFromRef]).editRoute
        const canMoveToRoute = isBetweenRoutes ? this.leanPlanningService.getRoutesActionsMap([routeToRef]).editRoute : true;

        if (!canMoveFromRoute || !canMoveToRoute) {
          this.resourcesAlertsService.timelineNoMatchingCompletedOrCanceledInfo();
          callback(null);
          return;
        }

        if (groupToRef.isRoute) {
          if (!_.isUndefined(routeToRef)) {
            toRouteId = _.get(routeToRef, 'id');
            isBetweenRoutes = !_.isEqual(fromRouteId, toRouteId);
          } else {
            this.resourcesAlertsService.timelineNoRoutesInfo();
            callback(null);
            return;
          }
        } else {
          allocationItems = this._allocationsToMoveTo(item);
          allocationIds = _.map(allocationItems, 'id');

          if (!allocationIds.length) {
            this.resourcesAlertsService.timelineNoAllocationInfo();
            callback(null);
            return;
          } else {
            const selectedAllocationId = allocationIds[0];
            const connectedRoute = _.find(this.routes, (r) => {
              return r.supplyResourceId === selectedAllocationId;
            })
            if (!!connectedRoute) {
              this.resourcesAlertsService.timelineMultipleRoutesOnAllocationInfo();
              callback(null);
              return;
            }
          }
        }

        if (!_.isEqual(item.startTime.valueOf(), item.start.valueOf()) &&
          !_.isEqual(item.endTime.valueOf(), item.end.valueOf())) {
          const isUnassigned = _.isEqual(_.get(routeToRef, 'status'), 'Unassigned');
          const header = groupToRef.isRoute ? (isBetweenRoutes ? 'Move service between routes' : 'Move service in route') : 'Create new route';
          const text = groupToRef.isRoute ?
            (isBetweenRoutes ? 'Would you like to move this service to a another route?' : 'would you like to move this service in the route?') :
            'You are about to create a new route';

          const actions = groupToRef.isRoute ? (_.isEqual(_.get(routeToRef, 'status'), 'Unassigned') ? this.commonsService.getConfirmActions(['Reset Services'])
            : this.commonsService.getConfirmActions(['Assign service to the route associated agent'])) : undefined;
          // var text = $filter('translate')(groupToRef.isRoute ? 'X_MOVE_ROUTE_ITEM_BETWEEN_ROUTES' : 'X_MOVE_ROUTE_ITEM_CREATE_ROUTE')(item);
          this.confirmDialogService.confirmWithActions(header, text, actions)
            .then((payload) => {
              // var groupToRef = groupsDataSet.get([item.group])[0];
              const fromResourceId = item.resourceId;
              const toResourceId = item.group.substring(item.group.indexOf("-") + 1);

              const groupsMap = this.timeline.components[3].groups;
              const isBetweenRoutes = !_.isUndefined(toRouteId) && (fromRouteId !== toRouteId);

              const fromOrderedIds = _.chain(groupsMap['routes-' + fromResourceId].orderedItems.byStart)
                .filter((orderedItem) => {
                  return !_.isEqual(orderedItem.data.type, 'background') &&
                    (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, fromRouteId));
                })
                .map((filteredItem) => {
                  return filteredItem.data.taskIdList || filteredItem.data.taskId;
                })
                .flatten()
                .value();

              const toOrderedIds = isBetweenRoutes ?
                _.chain(groupsMap[item.group].orderedItems.byStart)
                  .filter((orderedItem) => {
                    return !_.isEqual(orderedItem.data.type, 'background') &&
                      (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, toRouteId));
                  })
                  .map((filteredItem) => {
                    return filteredItem.data.taskIdList || filteredItem.data.taskId;
                  })
                  .flatten()
                  .value() : undefined;


              if (isBetweenRoutes) {
                const allTasks = _.flatMap(this.routes, 'taskListExt');
                const complementaryTaskIndex = this.tasksService.getComplementaryTaskIndex(item.ref, allTasks);

                if (complementaryTaskIndex > -1) {
                  const currentItemIndex = _.findIndex(toOrderedIds, (id) => {
                    return id === item.id;
                  })
                  const complementaryTaskRef = allTasks[complementaryTaskIndex];
                  const complementaryTaskId = allTasks[complementaryTaskIndex].bundledTaskList ?
                    _.find(allTasks[complementaryTaskIndex].bundledTaskList, (task: TaskModel) => {
                      return _.includes(serviceIds, task.serviceId);
                    }).id : complementaryTaskRef.id;
                  const isPickup = item.purpose === 'Pickup';
                  toOrderedIds.splice((isPickup ? (currentItemIndex + 1) : currentItemIndex), 0, complementaryTaskId);
                }
              }
              this.onMoveItem(
                {
                  serviceIds: serviceIds,
                  fromRouteId: fromRouteId,
                  toRouteId: toRouteId,
                  fromOrderedIds: fromOrderedIds,
                  toOrderedIds: toOrderedIds,
                  allocationInstanceId: _.get(allocationIds, 'length') ? allocationIds[0] : undefined,
                  originalId: item.ref?.originalId,
                  resourceId: _.get(allocationItems, 'length') ? allocationItems[0].group : undefined,
                  isBetweenDays: isBetweenDays,
                  toDate: item.start,
                  item: item,
                  assignServices: !isBetweenRoutes ? undefined : (isUnassigned ? undefined : payload[0].enabled),
                  resetServices: !isBetweenRoutes ? undefined : (isUnassigned ? payload[0].enabled : undefined),
                  callback: callback
                }
              );
            })
            .catch((error) => {
              callback(null);
              this.$log.info('onMoveTask Error', error);
            })
        } else {
          if (!item.ref.taskSpec.detailedServiceTime) {
            this.confirmDialogService.confirm('Update Task', 'Are you sure you want to update task?')
              .then(() => {
                const serviceTime = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));
                this.onTaskChange({
                  id: item.id,
                  routeId: fromRouteId,
                  serviceTime: serviceTime
                });
              })
              .catch((error) => {
                callback(null);
              })
          } else {
            const route = this.routes.find(r => r.id === fromRouteId);
            const taskServiceTime = _.get(route.analysis[item.id], 'serviceTime');
            let originTaskEta = _.get(route.analysis[item.id], 'eta');
            const originTaskEtd = _.get(route.analysis[item.id], 'etd') || (originTaskEta + taskServiceTime);

            const taskNotBefore = _.get(item.ref, 'taskSpec.notBefore');

            if (originTaskEta < taskNotBefore) {
              originTaskEta = taskNotBefore
            }

            const originDiff = originTaskEtd - originTaskEta;
            const updatedDiff = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));

            const percentageChange = updatedDiff / originDiff;

            const originalDetailedServiceTime = item.ref.taskSpec.detailedServiceTime;

            const updatedDetailedServiceTime: TaskDetailedServiceTimeModel = {
              entryTime: Math.round((originalDetailedServiceTime.entryTime || 0) * percentageChange),
              exitTime: Math.round((originalDetailedServiceTime.exitTime || 0) * percentageChange),
              workTime: Math.round((originalDetailedServiceTime.workTime || 0) * percentageChange),
              packagesTime: Math.round((originalDetailedServiceTime.packagesTime || 0) * percentageChange),
            }

            this.tasksDialogService.confirmDetailedServiceTimeChange(originalDetailedServiceTime, updatedDetailedServiceTime)
              .then((updatedDetailedServiceTime) => {
                this.onTaskChange({
                  id: item.id,
                  routeId: fromRouteId,
                  detailedServiceTime: updatedDetailedServiceTime
                });
              })
              .catch((error) => {
                callback(null);
              })
          }
        }
      },
      snap: (date, scale, step) => {
        const fifteenMinutes = 60 * 1000; // ticks of 15 minutes
        return Math.round(date / fifteenMinutes) * fifteenMinutes;
      },
      orientation: 'top',
      // editable: true,
      // selectable: true,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: true,                // drag items horizontally
        updateGroup: true,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: false          // allow these options to override item.editable
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      // stackSubgroups: false,
      tooltip: {
        followMouse: true
      },
      // maxMinorChars: 5,
      start: this.range.dateStart ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.range.dateEnd ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day'),
      min: this.range.dateStart ? this.moment(this.range.dateStart) : this.moment().startOf('day'),
      max: this.range.dateEnd ? this.moment(this.range.dateEnd) : this.moment().endOf('day'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);
    this.timeline.itemSet.groupHammer.off('tap');

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    // var addResourceButton = document.createElement('md-button');
    // addResourceButton.classList.add("md-raised", "md-accent");
    // addResourceButton.innerHTML = '+ ' +  $filter('translate')('Add Resource');
    // tableHeaderDivRef.appendChild(addResourceButton);

    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups
    this._initTimelineData(this.resources);


    // Init Allocations
    const itemsToAdd = this._getAllocationsItemsData(this.allocations);

    if (itemsToAdd.length) {
      this.itemsDataSet.add(itemsToAdd);
    }
    // Click Event
    this.timeline.on('click', (properties) => {
      if (properties.what === "group-label" && !properties.group.includes("routes-")) {
        this._toggleGroupRoutes(properties.group);
      }
    });

    // Double Click Event
    this.timeline.on('doubleClick', (properties) => {
      if (_.get(properties, 'item')) {
        const item = this.itemsDataSet.get(properties.item);
        if (_.get(item, 'serviceId')) {
          this.onViewService({id: item.serviceId});
        }
      }
    });

    // Right Click Event
    this.timeline.on('contextmenu', (properties) => {
      if (_.get(properties, 'item')) {
        const event = properties.event;
        const item = this.itemsDataSet.get(properties.item);
        this._onClicked().then(() => {
          this.onRightClickTask({task: item.ref, event: event});
        })
      }
      properties.event.preventDefault();
    });
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.resources && !changes.resources.isFirstChange()) {
      this.groupsDataSet.clear();
      this.groupsDataSet.add(this._getGroupsData(this.resources));
      this.$timeout(300).then(() => {
        this._setExpandedGroupsRoutes(this.isExpandedRoutes);
      })
    }

    if (changes.allocations && !changes.allocations.isFirstChange()) {
      this._clearAllocationsItems();
      const itemsToAdd = this._getAllocationsItemsData(this.allocations);

      if (itemsToAdd.length) {
        this.itemsDataSet.add(itemsToAdd);
      }

      // timeline.fit();
    }

    if (changes.routes && !changes.routes.isFirstChange()) {


      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');

      if (_.get(_.map(routesToRemove, 'id'), 'length')) {
        // groupsDataSet.remove(_.map(routesToRemove, 'id'));
        this.itemsDataSet.remove(_.map(routesToRemove, 'id'));
      }

      this._addRoutesToTimeline(_.uniqBy(routesToAdd, 'id'));
      // _updateGroupsNestedRoutes();

      if (!_.get(previousRoutes, 'length') && _.get(routesToAdd, 'length')) {
        this.onFit();
      }

      this.redrawGroupTemplate();
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      const currentTasks = changes.tasks.currentValue || [];
      const previousTasks = changes.tasks.previousValue || [];

      const tasksToAdd = _.differenceBy(currentTasks, previousTasks, 'id');
      const tasksToRemove = _.differenceBy(previousTasks, currentTasks, 'id');

      const currentTasksToUpdate = _.filter(currentTasks, (currentTask) => {
        const previousTask = _.find(previousTasks, ['id', currentTask.id]);
        // Check if task was changed
        return _.get(currentTask, 'updatedAt', 0) > _.get(previousTask, 'updatedAt', 0);
      });

      this._clearRoutesItems(_.map(tasksToRemove, 'id'));
      this._updateTimelineTasks(this._getTasksItemsData(currentTasksToUpdate));

      const taskItemsToAdd = this._getTasksItemsData(tasksToAdd);

      if (_.get(taskItemsToAdd, 'length')) {
        this.itemsDataSet.add(taskItemsToAdd);
      }
    }


    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getTimelineAllocationById(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this.options.min = this.moment(this.range.dateStart);
      this.options.max = this.moment(this.range.dateEnd);
      this.timeline.setOptions(this.options);
      this.timeline.setWindow(new Date(this.range.dateStart), new Date(this.range.dateEnd));
      // onFit();
    }

  }


  // ******************************
  //        Public methods
  // ******************************

  public onExpand(isExpandedRoutes) {
    this.isExpandedRoutes = isExpandedRoutes;
    this._setExpandedGroupsRoutes(isExpandedRoutes);
  }

  public onFit() {
    // var ids = _getRoutesItemIds();
    this.timeline.fit();
  }

  public _addRoutesToTimeline(routes) {
    // var groups = [];
    let backgroundItems = [];

    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
    });

    this.itemsDataSet.add(backgroundItems);

  }

  public _getRouteBackgroundItem(route) {
    return {
      id: route.rid,
      ref: route,
      routeId: route.rid,
      start: this.moment(route.notBefore),
      end: this.moment(route.notAfter),
      group: 'routes-' + _.get(route, 'planningResource.allocationId'),
      isRouteBackground: true,
      type: 'background',
      className: 'route-background'
    }
  }

  private onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupsData(resources) {

    const resourcesGroups = [];
    const routesGroup = [];

    _.forEach(resources, (r) => {
      resourcesGroups.push(this._getResourceGroup(r));
      routesGroup.push(this._getRoutesGroup(r));
    })

    return _.concat(resourcesGroups, routesGroup);
  }


  private _getTranslatedResourceSkills(requiredSkills, isFirstLetterOnly) {
    return _.map(requiredSkills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _getTasksItemsData(tasks) {

    const filteredTasks = _.filter(tasks, (t) => {
      const route = _.find(this.routes, (r) => {
        return _.isEqual(t.routeId, r.id) && _.includes(r.taskIdListExt, t.id);
      })
      return !!route;
    })

    return _.map(filteredTasks, (task: TaskModel) => {
      // var routeRef = _.find(ctrl.routes, function(r) {
      //   return r.id === task.routeId;
      // })

      //TODO REMOVE WHEN ROUTE ID ADDED TO TASKS
      let routeRef;
      if (!routeRef) {
        routeRef = _.find(this.routes, (r) => {
          return _.includes(r.taskIdListExt, task.id);
        })
      }

      if (!routeRef) {
        return false;
      }

      const groupId = routeRef.planningResource.allocationId;
      const routeColor = this.commonsService.getColorById(groupId);
      let index = _.findIndex(routeRef.taskIdListExt, (id) => {
        return id === task.id;
      }) + 1;

      const taskServiceTime = _.get(routeRef.analysis[task.id], 'serviceTime');
      const isPoint = _.isEqual(task.taskType, 'Internal');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      let taskEta = _.get(routeRef.analysis[task.id], 'eta');
      const taskEtd = _.get(routeRef.analysis[task.id], 'etd') || (taskEta + taskServiceTime);
      const relations = _.get(task, 'relations', []);
      const taskPurpose = task.taskSpec.purpose;
      const taskNotBefore = _.get(task, 'taskSpec.notBefore');

      if (taskEta < taskNotBefore) {
        taskEta = taskNotBefore
      }

      if (!_.get(task, 'routeAnalysis')) {
        _.set(task, 'routeAnalysis', {eta: taskEta, etd: taskEtd})
      }

      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
      let style = 'background-color: ' + routeColor + '; color: white;';

      if (isBundle) {
        style += ' box-shadow: 2px -2px 0px ' + this.commonsService.lightenDarkenColor(routeColor, -35) + ';';
      }

      return {
        ref: task,
        id: task.id,
        status: task.status,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        // group: groupId,
        group: 'routes-' + routeRef.planningResource.allocationId,
        resourceId: groupId,
        routeId: routeRef.rid,
        taskId: task.id,
        className: isPoint ? 'internal route-item' : (isBundle ? 'bundle route-item' : 'task route-item'),
        editable: {
          add: false,                          // add new items by double tapping
          updateTime: !routeRef.isBlockedByUser,                // drag items horizontally
          updateGroup: !routeRef.isBlockedByUser,              // drag items from one group to another
          remove: false                 // delete an item by tapping the delete button top right
        },
        // subgroup: route.rid,
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined, undefined, routeRef),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task, true) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true, index)),
        style: style,
      }
    });
  }

  private _getAllocationsItemsData(allocations) {
    let allAllocationItems = [];

    // return scheduleService.parseManyScheduleToEventsByRange(allocations, ctrl.range.from, ctrl.range.to, undefined, 'resourceAllocationId');

    _.forEach(allocations, (a) => {

      const allocationRecurringString = _.get(a, 'schedule.rrule', '');

      // OLD IMPLEMENTATION
      if (allocationRecurringString && false) {
        const ruleOptions = this.rrule.RRule.parseString(allocationRecurringString);

        ruleOptions.dtstart = this.moment(a.schedule.startRecurring).utc(true).toDate()
        if (a.schedule.endRecurring) {
          ruleOptions.until = this.moment(a.schedule.endRecurring).utc(true).toDate();
        }

        const rule = new this.rrule.RRule(ruleOptions);
        let dates = rule.between(new Date(this.range.dateStart), new Date(this.range.dateEnd));

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(a, 'schedule.exceptions', []);


        allAllocationItems = allAllocationItems.concat(
          this._parseReacquiringAllocationByTypeToItems(a, dates, exceptions) //ResourceAllocation | AgentSchedule
        );
      } else {
        allAllocationItems.push(this._parseTimeWindowAllocationToItem(a));
      }
    });

    return allAllocationItems;
  }

  private _parseReacquiringAllocationByTypeToItems(allocation, dates, exceptions) {

    if (exceptions.length) {
      dates = _.filter(dates, (d) => {
        const exception = _.find(exceptions, (e) => {
          return this.moment(d).isSame(this.moment(e), 'date');
        });
        return _.isUndefined(exception);
      });
    }
    return _.map(dates, (date) => {
      const dateToDifferenceInMili = this.moment(allocation.schedule.endTime).diff(this.moment(allocation.schedule.startTime));
      const dateFrom = this.moment(date).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date(),
        hour: this.moment(allocation.schedule.startTime).hours(),
        minute: this.moment(allocation.schedule.startTime).minutes(),
        second: this.moment(allocation.schedule.startTime).seconds()
      });
      const dateTo = this.moment(dateFrom.valueOf() + dateToDifferenceInMili);
      // var dateTo = moment(moment(dateFrom).valueOf() + dateToDifferenceInMili).set({
      //     hour:   moment(allocation.schedule.endTime).hours(),
      //     minute: moment(allocation.schedule.endTime).minutes(),
      //     second: moment(allocation.schedule.endTime).seconds()
      // });
      return {
        ref: allocation,
        isAllocation: true,
        startTime: dateFrom,
        endTime: dateTo,
        id: allocation.id,
        // id: allocation.id + ':Tag:' + allocation.resourceAllocationId + ':Date:' + this.moment(date).format("DD-MM-YYYY"),
        // id: moment(date).valueOf() + '-' + allocation.id, //ResourceAllocation | AgentSchedule
        allocationId: allocation.id,
        start: dateFrom,
        end: dateTo,
        // start: '2021-11-18',
        // end: '2021-11-19',
        content: this.$filter('timeWindow')({notBefore: dateFrom.valueOf(), notAfter: dateTo.valueOf()}),
        // start: dateFrom.format("YYYY-MM-DD"),
        // end: dateTo.add(1, 'days').format("YYYY-MM-DD"),
        group: allocation.resourceAllocationId,
        type: 'background',
        className: 'time-window'
      }
    })
  }


  private _initTimelineData(resources) {
    const groups = this._getGroupsData(resources);

    this.groupsDataSet.add(groups);
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineAllocationById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _getItemServiceAreaText(serviceAreas) {
    return serviceAreas.length > 1 ?
      _.toString(serviceAreas.length) + ' Service Areas' :
      _.get(serviceAreas, '[0].areaName', '');
  }

  private _getServiceAreaNames(serviceAreas) {
    let string = '';
    if (!serviceAreas || !serviceAreas.length) {
      return this.$filter('translate')('All');
    }
    if (serviceAreas.length > 2) {
      return this.$filter('translate')('X_SERVICE_AREA', serviceAreas);
    }
    _.forEach(serviceAreas, (area, i: number) => {
      string += area.areaName;
      if (i < (serviceAreas.length - 1)) {
        string += ', '
      }
    });
    return string;
  }


  private _setGroupVisibilityByQueryString(queryString) {
    const updatedGroups = [];

    this.groupsDataSet.forEach(function (group) {
      group.visible = !queryString ||
        _.includes(_.toLower(group.name), _.toLower(queryString)) ||
        _.includes(_.toLower(group.agentName), _.toLower(queryString));
      updatedGroups.push(group);
    });

    this.timeline.setGroups(updatedGroups);
  }

  private redrawGroupTemplate() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
    // timeline.setGroups(updatedGroups);
  }

  private _setExpandedGroupsRoutes(isEnabled) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.showNested = isEnabled;
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _toggleGroupRoutes(groupId) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      if (group.id === groupId) {
        group.showNested = !group.showNested;
      }
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _updateTimelineTasks(taskItems) {
    const tasksIds = _.map(taskItems, 'id');
    const itemsToUpdate = [];
    this.itemsDataSet.forEach((item) => {
      if (!item.isAllocation && !item.isRouteBackground && _.includes(tasksIds, item.id)) {
        itemsToUpdate.push(item.id);
      }
    });
    this.itemsDataSet.update(_.filter(taskItems, (t) => {
      return _.includes(itemsToUpdate, t.id)
    }));
  }

  private _clearAllocationsItems() {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (item.isAllocation) {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _clearRoutesItems(ids) {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (!item.isAllocation && (!ids || _.includes(ids, item.id))) {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _getRoutesItemIds() {
    const items = [];
    this.itemsDataSet.forEach((item) => {
      if (!item.isAllocation) {
        items.push(item.id);
      }
    });
    return items;
  }

  private _getServiceAreasByMap(areaIds) {
    return _.chain(areaIds)
      .map((areaId) => {
        return this.serviceAreasMap[areaId];
      })
      .filter((value) => {
        return !!value;
      })
      .value();
  }

  private _allocationsToMoveTo(task) {
    const allocations = [];
    if (_.isEqual(task.taskType, 'Internal')) {
      return allocations;
    }

    this.itemsDataSet.forEach((item) => {
      if (item.isAllocation && _.isEqual(task.group, item.group)) {
        if (_.isEqual(this.moment(task.start).valueOf(), this.moment(item.start).valueOf()) ||
          this.moment(task.start).isBetween(this.moment(item.start), this.moment(item.end))
        ) {
          allocations.push(item)
        }
      }
    });
    return allocations;
  }

  private _getResourceGroup(r) {
    return {
      id: r.id,
      name: r.name,
      vehicleName: _.get(r, 'vehicle.name', '---'),
      vehicleType: this.$filter('translate')(_.get(r, 'vehicle.type', '---')),
      agentType: this.$filter('translate')(_.get(r, 'agentType', '')),
      // requiredSkills: _getTranslatedResourceSkills(r),
      requiredSkills: r.requiredSkills,
      agentName: r.agentName || '---',
      branchesCount: _.get(r, 'branchIds.length', 'All'),
      maxDeliveries: _.get(r, 'capacity.numberOfDeliveries', '---'),
      className: 'group-row br-caption-2',
      ref: r,
      nestedGroups: ['routes-' + r.id],
      showNested: true
    }
  }

  private _getRoutesGroup(r) {
    return {
      isRoute: true,
      ref: r,
      id: 'routes-' + r.id,
      requiredSkills: r.requiredSkills
    }
  }

  private _parseTimeWindowAllocationToItem(allocation) {

    return {

      startTime: allocation.schedule.startTime,
      endTime: allocation.schedule.endTime,
      start: this.moment(allocation.schedule.startTime),
      end: this.moment(allocation.schedule.endTime),
      id: allocation.id,
      // id: allocation.id + ':Tag:' + allocation.resourceAllocationId + ':Date:' + this.moment(allocation.schedule.startTime).format("DD-MM-YYYY"),
      group: allocation.resourceAllocationId,
      ref: allocation,
      // content: _getTimeWindowAllocationContent(
      //   allocation.id,
      //   allocation.schedule.startTime,
      //   allocation.schedule.endTime,
      //   allocation.warnings,
      //   serviceAreas
      // ),
      content: this.$filter('timeWindow')({
        notBefore: allocation.schedule.startTime,
        notAfter: allocation.schedule.endTime
      }),
      isAllocation: true,
      className: 'time-window',
      type: 'background'
    }
  }

  $onDestroy() {
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourcesGanttTimelineTest', {
      bindings: {
        range: '<',
        sortType: '<',
        resources: '<',
        routes: '<',
        tasks: '<',
        totalResourcesCount: '<',
        allocations: '<',
        serviceAreas: '<',
        selectedItemId: '<',
        canEdit: '<',
        queryString: '<?',
        onMoveItem: '&',
        onTaskChange: '&',
        onViewService: '&',
        onRightClickTask: '&',
        onSortTypeChange: '&'
      },

      template: require('./resources-gantt-timeline-test.html').default,
      controller: ResourcesGanttTimelineTestCtrl
    }
  );
